export default __webpack_public_path__ + "static/wcut-37f9547f7c9ce510cde012fff6d068e7.jpg";